export default "__VITE_ASSET__DnJT_0kW__"